import Endpoints from 'constants/Endpoints';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET} from "libs/RestRequest";

const DEMAND_VALIDATION_RESOURCE_ID = "demandValidation";


const getPreparingSections = async (id, clear = true) => {
    await getSections(id, clear, Endpoints.DEMAND_PREPARING_SECTIONS);
}

const getEvaluationSections = async (id, clear = true) => {
    await getSections(id, clear, Endpoints.DEMAND_EVALUATION_SECTIONS);
}

const getFinishingSections = async (id, clear = true) => {
    await getSections(id, clear, Endpoints.DEMAND_FINISHING_SECTIONS);
}

const getSections = async (id, clear = true, urlFn) => {
    if (clear) {
        clearResource(DEMAND_VALIDATION_RESOURCE_ID)
    }

    try {
        const res = await RestRequestGET(urlFn(id));
        reduxStore.dispatch(setResource(DEMAND_VALIDATION_RESOURCE_ID, res))
    } catch (error) {
    }
}

const clearDemandValidationResources = () => reduxStore.dispatch(clearResource(DEMAND_VALIDATION_RESOURCE_ID));

export default {
    getPreparingSections,
    getEvaluationSections,
    getFinishingSections,
    clearDemandValidationResources,
    DEMAND_VALIDATION_RESOURCE_ID
}